import React from 'react';
import styled from 'styled-components';
import CardBaseInput from './CardBaseInput';

class CardCountrySelect extends CardBaseInput {
  componentDidMount() {
    const { autoDetectCountry = false, onChange = () => {} } = this.props;
    const elem = window.jQuery('.selectpicker');
    elem.countrypicker();
    elem.selectpicker();
    elem.on('changed.bs.select', (e) => {
      const country = e.target.value || '';
      this.setInputTouched(false);
      onChange && onChange(country);
    });

    // auto detect country when set
    if (autoDetectCountry) this.detectCountry();
  }

  async detectCountry() {
    const apiKey = '8f013592f7b70ef7a3be7ef5ebd002c4';
    const url = `//api.ipstack.com/check?access_key=${apiKey}`;
    const result = await fetch(url).then(response => response.json());
    const elem = window.jQuery('.selectpicker');
    elem.selectpicker('val', result.country_code);
  }

  render() {
    const {
      onChange, // remove onChange
      defaultValue,
      autoDetectCountry: _oAutoDetectCoutnry,
      ...rest
    } = this.props;

    const props = {
      'aria-label': 'Country',
      autoComplete: 'shipping country',
      id: 'country',
      name: 'country',
      placeholder: 'Country',
      ...rest,
      'data-live-search': true,
      'data-size': 7,
      'data-default': defaultValue,
    };

    const { touched, error } = this.state;

    return (
      <SelectWrapper className="input-area">
        <select className="selectpicker countrypicker" {...props}></select>
        <div className="error-view">{touched && error}</div>
      </SelectWrapper>
    );
  }
}

const SelectWrapper = styled.div`
  .bootstrap-select {
    width: 100% !important;

    button {
      display: flex;
      padding: 12px 15px;
      box-shadow: none !important;

      .filter-option {
        font-family: "Open Sans", sans-serif;
        font-weight: 500;
        font-size: 1.5rem;
      }
    }

    .dropdown-menu {
      width: 100%;

      .bs-searchbox {
        input {
          height: 40px;
        }
      }
    }
  }
`;

export default CardCountrySelect;
